<template>
    <div>
        <div v-for="header in headers" :key="header.title">
            <v-card-title>{{ header.title }}</v-card-title>
            <v-card-text class="body-1" v-if="header.body">{{
                header.body
            }}</v-card-text>
            <component
                v-if="header.comp"
                :is="header.comp.name"
                v-bind="{ ...header.comp.props }"
                :class="header.comp.classes"
            />
        </div>
        <v-card-title>Accelerated Lab FAQ:</v-card-title>
        <v-expansion-panels v-model="panels" class="soli-round" accordion>
            <v-expansion-panel v-for="FAQ in FAQS" :key="FAQ.question">
                <v-expansion-panel-header class="font-weight-bold">{{
                    FAQ.question
                }}</v-expansion-panel-header>
                <v-expansion-panel-content
                    ><div
                        v-if="FAQ.answer"
                        v-html="FAQ.answer"
                        class="body-1" />
                    <component
                        v-if="FAQ.comp"
                        :is="FAQ.comp.name"
                        v-bind="{ ...FAQ.comp.props }"
                        :class="FAQ.comp.classes"
                /></v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import IndentList from "./IndentList.vue";
import RenderList from "./RenderList.vue";

export default {
    components: {
        RenderList,
        IndentList,
    },
    props: {
        location: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            panels: null,
            locationPrices: [],
        };
    },
    computed: {
        headers() {
            return [
                {
                    comp: {
                        name: "SoliVideoPlayer",
                        classes: ["mx-4 my-2"],
                        props: {
                            src: "https://player.vimeo.com/video/733745035?h=231a9b1adf",
                        },
                    },
                },
                {
                    title: "Musicologie’s Accelerated Lab",
                    body: `Experience Simply Delightful Music Lessons with Musicologie! We are a premier music education company for ages 6 months through adults. Our programs are specifically designed to make learning and playing music fun for all ages, abilities and instruments.
                            Our Accelerated Labs are an innovative approach that makes learning the basics faster and more fun. Lab students move faster through their music, are better at practicing, and are more self-sufficient learners. For most beginning to intermediate students, it’s the best way to learn.
                            `,
                },

                {
                    title: "Our Approach to Music Lessons",
                    body: `At Musicologie we know that music lessons are one of the most impactful investments you can make in yourself or in your child. Learning music improves coordination, language, reading and math skills. It nurtures our emotional and cognitive health. Studying an instrument makes our brains bigger and reduces chances of hearing loss and dementia in adults. Plus, it’s fun! We are proud to have a holistic private lesson program that shares music and its benefits with students of all ages and abilities.`,
                },

                /*{
                    title: "Getting started with Accelerated Lab",
                    body: `The first step is to submit your information and we’ll find a time for you in one of our Labs. At your first Lab, please arrive 10 minutes early. You’ll get a tote, t-shirt and welcome folder, get registered, spend some one on one time with your teacher, and buy any necessary books. Lab is ${this.getPrice(
                        "Accelerated Piano Lab Membership"
                    )} per month at Musicologie ${
                        this.location.name
                    } with a ${this.getPrice(
                        "Accelerated Piano Lab Enrollment Fee"
                    )} registration fee. It’s backed by our Perfect Match Promise. We want you to LOVE your experience at Musicologie. If you don’t, we’ll refund your first payment, no questions asked. `,
                },*/
            ];
        },
        FAQS() {
            return [
                {
                    question: `How does Accelerated Lab work?`,
                    answer: `In our Accelerated Labs, three to five students work separately at their instruments with headphones, alternating between interacting with the teacher and independent learning. The Lab is compatible with any curriculum, preferred method or repertoire. In addition, Lab students work from Musicologie’s excellent Lab curriculum which fills learning gaps and makes drilling scales and technique fun!`,
                },
                {
                    question:
                        "Why should I choose Lab over traditional private lessons?",
                    comp: {
                        name: "IndentList",
                        classes: ["px-2"],
                        props: {
                            items: [
                                "· Lab dramatically improves a student’s sight reading skills. This is the biggest skill that students need in order to learn music quickly.",
                                "· Students move through their books faster.",
                                "· Students learn more music each week.",
                                "· Includes proven practice techniques so home practice is all about review and increasing speed.",
                                "· Less tedium = more fun at home.",
                                "· Minimizes the parent’s need to supervise practice at home. Fewer battles about practicing and just more fun!",
                            ],
                        },
                    },
                },
                {
                    question: "Who is Accelerated Lab for?",
                    answer: `Accelerated Lab is perfect for students who are beginning to intermediate level, age 7 or older, and capable of 5-10 minutes of independent work at a time. Lab is available for piano, guitar, and drums. Check your location for schedule and availability.`,
                },
                {
                    question: "How do I get started?",
                    answer: `The first step is to submit your information and we’ll find a time for you in one of our Labs. At your first Lab, please arrive 10 minutes early. You’ll get a tote, t-shirt and welcome folder, get registered, spend some one on one time with your teacher, and buy any necessary books.`,
                },
                {
                    hidden: !this.location,
                    question: "What's the pricing?",
                    answer: `Lab is ${this.getPrice(
                        "Accelerated Lab Membership"
                    )} per month and  ${this.getPrice(
                        "Accelerated Lab First Visit"
                    )} for the first class.  It’s backed by our Perfect Match Promise. We want you to LOVE your experience at Musicologie. If you don’t, we’ll refund your first payment, no questions asked.`,
                },
                {
                    question: "Can a beginner do Accelerated Lab?",
                    answer: "Yes! Lab is perfect for beginners because they’ll rocket through their lesson books and learn the basics of reading and playing way faster than traditional 30-minute lessons.",
                },
                {
                    question: "Is there a sibling or family discount?",
                    answer: "Yes. There is a 3% discount off your entire invoice if more than one family member is taking lessons. The discount is applied automatically and you'll see it on your monthly invoice.",
                },
                {
                    question: "What’s Musicologie’s withdrawal policy?",
                    answer: "To withdraw from lessons and end automatic billing, all you need to do is fill out the quick form at https://musicologie.com/exit 30 days before your last lesson. Your withdrawal is not processed until you fill out that form. We require 30 days notice, which begins the day that form is received. Your final invoice will be prorated the last 30 days.",
                },
                {
                    question:
                        "What’s Musicologie’s single Lab cancellation policy?",
                    answer: "You can cancel or change your weekly Lab up to 30 minutes before your Lab time. If you cancel, that canceled Lab stays on your account and you can reschedule it at any time in the future. Canceled Labs never expire as long as you’re a current student.",
                },
                {
                    question: "How do I reschedule a Lab?",
                    answer: "Log into your account at Musicologie.com to view your schedule and select any Lab to cancel or change. You can cancel or change up to 30 minutes before the Lab.",
                },
            ].filter((e) => !e.hidden);
        },
    },
    methods: {
        getPrice(product) {
            if (!this.locationPrices.length) return "(...loading)";
            return this.formatUnitAmount(
                this.locationPrices.find((e) => e.name == product).amount
            );
        },
        getLocationPricing() {
            if (!this.location) return;

            axios
                .get(route("stripe.locationPricing"), {
                    params: {
                        location_id: this.location.id,
                    },
                })
                .then((resp) => {
                    this.locationPrices = resp.data;
                });
        },
    },
    mounted() {
        this.getLocationPricing();
    },
};
</script>
